/* Product information drawers: lock scroll without moving the page */
var informationModalSavedStyles = null;

function LockInformationModalScroll()
{
    if (informationModalSavedStyles) return;

    informationModalSavedStyles = {
        bodyOverflow: document.body.style.overflow,
        htmlOverflow: document.documentElement.style.overflow
    };

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
}

function UnlockInformationModalScroll()
{
    if (!informationModalSavedStyles) return;
    if (document.querySelector(".product__information-modal.active")) return;

    document.body.style.overflow =
        informationModalSavedStyles.bodyOverflow;

    document.documentElement.style.overflow =
        informationModalSavedStyles.htmlOverflow;

    informationModalSavedStyles = null;
}

function OpenInformationModal(link)
{
    var modalID = link.dataset.blockId;

    var modal = Array.from(
        document.querySelectorAll(".product__information-modal")
    ).find(function (item)
    {
        return item.dataset.blockId === modalID;
    });

    if (modal)
    {
        LockInformationModalScroll();
        modal.classList.add("active");
    }
}

function CloseInformationModal(btn)
{
    var parentModal = btn.closest(".product__information-modal");

    if (parentModal)
    {
        parentModal.classList.remove("active");
        UnlockInformationModalScroll();
    }
}

function HandleInformationModalsClick()
{
    document.querySelectorAll(
        ".product__information-modal-link"
    ).forEach(function (link)
    {
        link.addEventListener("click", function (e)
        {
            e.preventDefault();
            OpenInformationModal(e.currentTarget);
        });
    });

    document.querySelectorAll(
        ".product__information-modal .product__informaiton-modal-close"
    ).forEach(function (btn)
    {
        btn.addEventListener("click", function (e)
        {
            e.preventDefault();
            CloseInformationModal(e.currentTarget);
        });
    });

    document.addEventListener("keydown", function (e)
    {
        if (e.key === "Escape")
        {
            document.querySelectorAll(
                ".product__information-modal.active"
            ).forEach(function (modal)
            {
                modal.classList.remove("active");
            });

            UnlockInformationModalScroll();
        }
    });
}

HandleInformationModalsClick();